<div *ngIf="providerDetails" class="booking-card sidebar shadow-sm">
  <div
    *ngIf="selectedBookingService && step !== bookingStepsEnum.SERVICES"
    class="mb-4"
  >
    <p class="text-sm font-bold text-grey-4">Tjänst</p>
    <p *ngIf="selectedGroup" class="text-lg font-bold">{{ selectedGroup.careServiceName }}</p>
    <p>{{ selectedBookingService.name }}</p>
    <p *ngIf="selectedDateTimeForDisplay" class="font-medium text-apricot-1">{{ selectedDateTimeForDisplay }}</p>
  </div>
  <p class="text-sm font-bold text-grey-4">Plats</p>
  <div
    (click)="navigateToCareproviderUnit()"
    class="mb-1 cursor-pointer text-lg font-bold"
  >
    {{ providerDetails.name }}
  </div>

  <div *ngIf="providerDetails.location" class="contact-info__content__item">
    <app-ui-icon color="var(--duck-blue-2)" name="marker" size="md"></app-ui-icon>
    <a (click)="openMap()">
      <span *ngIf="providerDetails.location.visitingAddress !== null">{{
        providerDetails.location.visitingAddress
        }}</span>
      <span *ngIf="providerDetails.location.visitingAddress === null"
      >{{ providerDetails.location.street }},
        {{ providerDetails.location.zip }}
        {{ providerDetails.location.city }}</span
      >
    </a>
  </div>
  <div class="contact-info">
    <div *ngIf="isExpanded" class="contact-info__content">
      <div
        *ngFor="let item of providerDetails.contactInfo.phoneNumbers"
        class="contact-info__content__item"
      >
        <app-ui-icon color="var(--duck-blue-2)" name="phone" size="md"></app-ui-icon>
        <span>
          {{ item.number }}
          <span *ngIf="item.label"
          ><i> ({{ item.label }})</i></span
          >
        </span>
      </div>
      <div
        *ngIf="providerDetails.contactInfo?.webSiteUrl"
        class="contact-info__content__item"
      >
        <app-ui-icon
          color="var(--duck-blue-2)"
          name="website"
          size="md"
        ></app-ui-icon>
        <span class="break-all">{{
          providerDetails.contactInfo.webSiteUrl
          }}</span>
      </div>
    </div>

    <div (click)="toggleExpand()" class="contact-info__header mb-4">
      <span>Kontaktuppgifter</span>
      <app-ui-icon
        [name]="isExpanded ? 'chevron_collapse' : 'chevron_expand'"
        color="var(--duck-blue-2)"
        size="sm"
      ></app-ui-icon>
    </div>
    <div class="flex gap-6">
      <div
        *ngIf="selectedBookingService &&
        ((selectedBookingService.price !== null && selectedBookingService.price !== '') ||
        (selectedBookingService.priceDescription !== null && selectedBookingService.priceDescription !== ''))">
        <app-price-info
          [activityLength]="null"
          [isFromPrice]="selectedBookingService.isFromPrice"
          [parentCssClass]="'flex flex-col'"
          [priceDescription]="selectedBookingService.priceDescription"
          [price]="selectedBookingService.price"
        ></app-price-info>
      </div>

      <div *ngIf="practitionerName" class="flex flex-col">
        <span class="text-sm font-bold text-grey-4">Utövare</span
        ><span class="text-apricot-1">{{ practitionerName }}</span>
      </div>
    </div>
    <div
      (click)="openTreatmentDetailsModal()"
      *ngIf="
        selectedBookingService?.seoInformation &&
        selectedBookingService.seoInformation !== ''
      "
      class="my-4 cursor-pointer font-bold text-duck-blue-2"
    >
      Mer om behandlingen
    </div>
    <div *ngIf="selectedBookingService?.note" class="mt-4 text-sm text-grey-4">
      <div class="font-bold">Information från vårdgivaren:</div>
      <p class="max-w-prose">{{ selectedBookingService.note }}</p>
    </div>
  </div>
</div>
